export const getThumbnailUrl = (mediaUrl: string): string | undefined => {
  // Extract the Vimeo video ID from the VideoUrl
  const videoId = mediaUrl?.match(/video\/(\d+)/)?.[1];

  // Construct the thumbnail URL
  const thumbnailUrl = videoId ? `https://vumbnail.com/${videoId}.jpg` : undefined;
  return thumbnailUrl;
};
